import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Button from "./Button";
import DropdownButton from "./DropdownButton";
import Icon from "./Icon";
import Moment from "./Moment";
import styles from "./CampaignListItem.module.css";
import { history } from "../history";

export default class CampaignListItem extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.onClone = this.onClone.bind(this);
    this.onDelete = this.onDelete.bind(this);
  }

  onClone() {
    const { id } = this.props.campaign;
    this.props.onClone(id);
  }

  onDelete() {
    const { id } = this.props.campaign;
    this.props.onDelete(id);
  }

  handleClick() {
    const { id } = this.props.campaign;
    const { accountId } = this.props;
    history.push(`/clients/${accountId}/campaigns/${id}`);
  }

  render() {
    const { id, name, updatedAt, updatedByName, EmailTemplate } =
      this.props.campaign;
    const { accountId } = this.props;

    return (
      <tr>
        <td className={styles.name} onClick={this.handleClick}>
          <Icon icon="folder-open" />
          {` `}
          {name}
        </td>
        <td style={{ width: "150px" }} onClick={this.handleClick}>
          {updatedByName}
        </td>
        <td style={{ width: "180px" }}>
          <Moment date={updatedAt} />
        </td>
        <td style={{ width: "300px", textAlign: "right" }}>
          <DropdownButton
            type="link"
            pin="right"
            options={[
              {
                label: "Delete",
                onClick: this.onDelete,
              },
            ]}
          />
        </td>
      </tr>
    );
  }
}

CampaignListItem.propTypes = {
  accountId: PropTypes.string.isRequired,
  campaign: PropTypes.object.isRequired,
  onClone: PropTypes.func,
  onDelete: PropTypes.func.isRequired,
};
